import { FuseLoadable } from '@fuse';
import React from 'react';

export const DadosEmpresaConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/dadosempresa',
            component: FuseLoadable({
                loader: () => import('./DadosEmpresaApp')
            })
        },
    ]
};
